export class TicketPrint {
    constructor(data) {
        this.id = data.id ?? 0;
        this.disclaimer = data?.disclaimer ?? "";
        this.movieTitle = data?.movieTitle ?? "";
        this.movieRating = data?.movieRating ?? "";
        this.ticketDetails = data?.ticketDetails ?? "";
        this.ticketType = data?.ticketType ?? "";
    }
}